module.exports = "/images/sz.svg?97e098a5f8988fc205cc45c63fb433ea";